/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { useState } from 'react';
import { useNotify, useDataProvider } from 'react-admin';

import { arrayMove } from '@dnd-kit/sortable';

export const useOrderResource = () => {
  const [progress, setProgress] = useState(null);
  const notify = useNotify();
  const dataprovider = useDataProvider();

  const dragEnd = (items, active, over) => {
    if (active.id !== over.id) {
      const oldIndex = active.data.current.sortable.index;
      const newIndex = over.data.current.sortable.index;

      let sortedItems = arrayMove(items, oldIndex, newIndex);
      return {
        sortedItems: sortedItems,
        oldIndex: oldIndex,
        newIndex: newIndex > oldIndex ? newIndex + 1 : newIndex,
      };
    }
  };

  const order = async (resource, params, data) => {
    try {
      const { item, weight } = data;

      setProgress(25);

      await dataprovider.orderResource(resource, {
        item: item,
        weight: weight,
      });

      setProgress(75);

      // Refresh the list, the data will be refreshed automatically
      await dataprovider.getList(resource, params);
    } catch (e) {
      console.error(e);
      notify('Error while moving resource', 'warning');
    } finally {
      setProgress(null);
    }
  };

  return { order, dragEnd, progress };
};
